"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FormSubmitter_1 = require("../../Components/Form/FormSubmitter");
const FormValidator_1 = require("../../Components/Form/FormValidator");
const Druid_1 = require("../../Druid");
class FormUtil {
    /**
     * Gather form data from `form`, augmented with `data`, and post to given `url`
     *
     * @param form    the form to post
     * @param url     the url to post to
     * @param data    the optional extra data to post
     * @param options
     *         - includeDisabled: see HTMLElement.getFormData
     *         - disableForm: disable form on submit, enable on completion
     */
    static postForm(form, url, data, options) {
        return new FormSubmitter_1.default(form, options).submit(url, data);
    }
    /**
     * If the request failed due to form errors, mark the invalid fields
     *
     * @param form the form to update with FormErrors
     * @param json the json from NotifyFactory::formError response
     */
    static setFormErrors(form, json) {
        if (json.notify !== 'formError' || json.errors === undefined) {
            return;
        }
        new FormValidator_1.default(form).setInvalid(Object.keys(json.errors));
    }
    /**
     * Disable all `dr-form` form elements. Keep track of which already were disabled. When enabling the form elements
     * again only, the elements disabled with this function will be enabled again.
     */
    static disableForm(form, disable, options) {
        var _a;
        const selector = (_a = options === null || options === void 0 ? void 0 : options.selector) !== null && _a !== void 0 ? _a : '.' + Druid_1.default.configuration().form.className;
        form.querySelectorAll(selector).forEach((element) => {
            var _a;
            if (((_a = options === null || options === void 0 ? void 0 : options.exclude) === null || _a === void 0 ? void 0 : _a.call(options, element)) === true) {
                return;
            }
            // enable only previously disabled elements
            if (disable === false) {
                if (element.dataset.disabledBy === 'disableForm' || (options === null || options === void 0 ? void 0 : options.alwaysEnable) === true) {
                    delete element.dataset.disabledBy;
                    element.removeAttribute('disabled');
                }
                return;
            }
            // already disabled
            if (element.hasAttribute('disabled')) {
                return;
            }
            // disable element, and register disableForm disabled it
            element.dataset.disabledBy = 'disableForm';
            element.setAttribute('disabled', 'disabled');
        });
    }
    /**
     * Set the value of all elements within this form to empty
     */
    static resetForm(form, selector) {
        const elements = form.querySelectorAll(selector !== null && selector !== void 0 ? selector : '.' + Druid_1.default.configuration().form.className);
        elements.forEach((element) => {
            if (element.type === 'checkbox' || element.type === 'radio') {
                element.checked = false;
            }
            else {
                element.value = '';
            }
        });
    }
    /**
     * Use native browser function "reportValidity" function on all form elements. Stop on first failure
     *
     * @return {boolean} true if the form is valid
     */
    static reportValidity(form, options) {
        return new FormValidator_1.default(form, options).reportValidity();
    }
}
exports.default = FormUtil;
//# sourceMappingURL=FormUtil.js.map